import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Objects, Collections} from "components";

import {Tabs, Tab} from "@material-ui/core";
import Access from "constants/Access";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Products / Firearms',
		url: '/products',
		icon: 'barcode',
	},
	{
		name: 'UPC Center',
		url: "/products/upc_center",
		icon: 'list-ul',
	},
];

export default class UPC extends Framework.Components.View {

	constructor(props) {
		super(props, 'details');
	}
	render() {
		
		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: this.props.id,
				url: `/products/upc_center/${this.props.id}`,
				
			}
		]);

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}/>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Details" value="details"/>

					{/*Todo: Do we need to worry about User Access?  I noticed in Product.js we do. */}
					<Tab label="Change Log" value="logs"/>
				</Tabs>
				<div style={{display: this.state.tab === 'details' ? 'block' : 'none'}}>
					<Objects.UPC
						id={this.props.match.params.id}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						updateName={this.updateName}
						baseUrl={this.props.baseUrl}
					/>
				</div>
				{/*Todo: Do we need to worry about User Access here as well?*/}
				{this.state.tab === 'logs' &&
					<Collections.LogsUPC
						parent={this.props.match.params.id}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
					/>}
			</div>


	);
	}
};